import React, { useState, useEffect } from "react";
import { Typography, Divider, Skeleton, Flex } from "antd";
import { fetchData } from "../../utils/fetch";

const { Title } = Typography;

export function ContentPage({ pageLink, type }) {
  const [mainPage, setMainPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadPage() {
      try {
        const data = await fetchData(`front/${type}/${pageLink}`);
        setMainPage(data);
      } catch (error) {
        console.error("Error loading menu items:", error);
      } finally {
        setLoading(false);
      }
    }
    loadPage();
  }, [pageLink, type]);

  useEffect(() => {
    document.title = mainPage?.title || "Loading...";
  }, [mainPage]);

  if (loading) {
    return <Skeleton active></Skeleton>
  }

  if (mainPage === null) {
    return (<div></div>)
  }

  return (
    <div className="contentPage" key={pageLink}>
        {loading ? 
          <Skeleton active></Skeleton>
        :
          <Flex vertical justify="center" align="center" style={{margin: "0 10% 0 10%"}}>
            <Divider/>
            <div className={`ql-editor ${type}`} dangerouslySetInnerHTML={{ __html: mainPage.content }}></div>
            <Divider/>
          </Flex>
        }
    </div>
  );
}
